import Services from './sdkServices';

export const getTopFolderUrn = async (projectId) => {
  // For the plugin framework limitation,
  // it has to call folder API first to refetch the top folder urns
  const data = await Services.Folders.getFolders(projectId);
  const folders = data.filter((entity) =>
    ['normal', 'shared'].includes(entity.folderType),
  );
  if (folders.length <= 0) return null;

  // Return all available top folder urns
  return folders.map(({ urn }) => urn);
};
